(() => {
  document.querySelectorAll('[data-filter-form]').forEach(form => {
    const minimum = form.querySelector('[data-price-min]');
    const maximum = form.querySelector('[data-price-max]');
    const error = form.querySelector('[data-price-error]');
    if (!minimum || !maximum || !error) return;
    const validate = () => {
      const inverted = minimum.value !== '' && maximum.value !== '' && minimum.valueAsNumber > maximum.valueAsNumber;
      maximum.setCustomValidity(inverted ? error.textContent : '');
      maximum.setAttribute('aria-invalid', String(inverted));
      error.hidden = !inverted;
      return !inverted;
    };
    form.addEventListener('input', event => {
      if ((event.target === minimum || event.target === maximum) && !error.hidden) validate();
    });
    form.addEventListener('submit', event => {
      if (!validate()) {
        event.preventDefault();
        maximum.focus();
        maximum.reportValidity();
      }
    });
    form.addEventListener('formdata', event => {
      for (const input of [minimum, maximum]) if (input.value === '') event.formData.delete(input.name);
    });
    if (!validate()) {
      const disclosure = form.closest('.mobile-filter');
      if (disclosure) disclosure.open = true;
    }
  });
})();
